var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0006 0.241119C5.12178 1.26551 1.23712 5.1767 0.240312 10.0683C-0.080104 11.6402 -0.080104 13.5843 0.240312 15.1562C1.24452 20.0841 5.14655 23.9862 10.0745 24.9904C14.2284 25.837 18.564 24.5364 21.5534 21.5471C25.7621 17.3383 26.4577 10.7416 23.2207 5.7349C21.4029 2.92322 18.4428 0.90249 15.1624 0.234077C13.6186 -0.0805884 11.519 -0.0777716 10.0006 0.241119ZM9.6346 13.6581C8.57195 12.6742 7.95518 11.1911 7.78851 9.2184L7.71328 8.32828H6.49805H5.28293L5.28375 8.70973C5.2854 9.46793 5.61309 11.2546 5.91907 12.1732C6.48514 13.8731 7.41575 15.171 8.66279 16.0001C9.71195 16.6976 11.0213 17.1301 12.3424 17.2158L13.3814 17.283V15.6665V14.05L13.7628 14.1252C14.9219 14.3537 16.4293 15.6186 16.8475 16.7137L17.0517 17.2483H18.3215H19.5914L19.4226 16.7695C18.9142 15.329 17.9179 14.0519 16.6412 13.2047L15.969 12.7587L16.4064 12.4388C17.5665 11.5901 18.7363 9.88787 18.969 8.70973L19.0444 8.32828H17.9277H16.8111L16.3914 9.21206C16.116 9.79186 15.7494 10.3181 15.3254 10.7421C14.7397 11.328 13.9062 11.8401 13.5281 11.8468C13.4172 11.8487 13.3814 11.4204 13.3814 10.0888V8.32828H12.2077H11.034V11.4324V14.5366L10.6727 14.4107C10.474 14.3414 10.0069 14.0027 9.6346 13.6581Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconVk);
export default __webpack_public_path__ + "static/media/SocialIconVK.043e1cf2e3178148f5fe3f77d5ffa627.svg";
export { ForwardRef as ReactComponent };